import { StateCreator } from 'zustand';
import AccessCodeDetails from '@interfaces/access-code-details';
import UserDetails from '@interfaces/user-details';
import { UserDetailsStore } from '@interfaces/user-details-store';

const userDetailsIntialState: UserDetails = {
  status: '',
  userId: '',
  userInformation: {
    firstName: '',
    lastName: '',
    emailAddress: '',
    cceName: '',
    userRole: '',
    userType: '',
    userSubType: '',
    county: [],
    state: '',
    npiId: '',
    ssoId: '',
    roleStateInfo: []
  },
  jwtToken: ''
};
const accessCodeDetails: AccessCodeDetails = {};
const initialState = {
  userDetails: userDetailsIntialState,
  virtualMode: false,
  virtualState:'',
  isNC: false,
  isCarelonRx: false,
  accessCodeDetails: accessCodeDetails,
  bannerContent: null
};

export const createUserStoreSlice: StateCreator<UserDetailsStore> = (set) => ({
  ...initialState,
  updateUserDetails: (userDetails: UserDetails) => set({ userDetails }),
  updateBannerContent: (bannerContent: any) => set({ bannerContent }),
  updateVirtualMode: (virtualMode: boolean) => set({ virtualMode }),
  updateVirtualState: (virtualState: string) => set({ virtualState }),
  updateIsNC: (isNC: boolean) => set({isNC}),
  updateIsCarelonRx: (isCarelonRx: boolean) => set({isCarelonRx}),
  updateAccessDetails: (accessCodeDetails: AccessCodeDetails) =>
    set({ accessCodeDetails }),
  resetUserDetails: () =>
    set({
      userDetails: userDetailsIntialState,
      virtualMode: false,
      accessCodeDetails: accessCodeDetails
    }),
  resetAccessDetails: () =>
    set({
      accessCodeDetails: accessCodeDetails
    }),
  resetBannerContent: () => set({ bannerContent: null })
});
